export const defaultLocale = 'en' as const;
export const localizationDefaultLocale = defaultLocale;
export const routingDefaultLocale = defaultLocale;

export const routingLocales = ['en', 'de', 'pl'] as const;

export const localizationLocales = [
  {
    code: 'de',
    label: 'German',
  },
  {
    code: 'en',
    label: 'English',
  },
  {
    code: 'pl',
    label: 'Polish',
  },
];

type RoutingLocale = (typeof routingLocales)[number];

type RoutingDomains = Array<{
  defaultLocale: RoutingLocale;
  domain: string;
  locales: Array<RoutingLocale>;
}>;

const productionRoutingDomains: RoutingDomains = [
  {
    defaultLocale: 'en',
    domain: 'en.stroll.no',
    locales: ['en'],
  },
  {
    defaultLocale: 'de',
    domain: 'de.stroll.no',
    locales: ['de'],
  },
  {
    defaultLocale: 'pl',
    domain: 'pl.stroll.no',
    locales: ['pl'],
  },
];

const developmentRoutingDomains: RoutingDomains = [
  {
    defaultLocale: 'en',
    domain: 'stroll.localhost',
    locales: [...routingLocales],
  },
];

export const routingDomains =
  process.env.NODE_ENV === 'production' ? productionRoutingDomains : developmentRoutingDomains;
